import React, { useEffect, useState } from "react";
import { HelpingRoutes } from "../../models";
import { getWindowWidth } from "../../services";
import styles from "./help.scss";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";
import Advertising from "./Advertising";
import InstructionsForUse from "./InstructionsForUse";
import FAQ from "./FAQ";
import history from "../../history";
import PaymentMethods from "./PaymentMethods";
import CustomTabs from "../CustomTabs/CustomTabs";

const defaultSettings = {
  tab: {
    leftMinWidth: 800
  }
};

function Help(props: any) {
  const {
    match: {
      params: { menu }
    }
  } = props;

  const [activeKey, setActiveKey] = useState(menu);
  const [tabPosition, setTabPosition] = useState("");

  useEffect(() => {
    setActiveKey(menu);
    changeTabPosition();
    window.addEventListener("resize", changeTabPosition);

    return () => {
      window.removeEventListener("resize", changeTabPosition);
    };
  }, [menu]);

  const onChange = (key: string) => {
    history.replace(key);
    setActiveKey(key);
  };

  const changeTabPosition = () => {
    setTabPosition(
      getWindowWidth() > props.settings.tab.leftMinWidth ? "left" : "top"
    );
  };

  const isVertical = tabPosition === "left";

  return (
    <div className="child-center">
      <div className={styles.tabs}>
        <CustomTabs
          activeKey={activeKey}
          onChange={onChange}
          vertical={isVertical}
          tabs={[
            { key: HelpingRoutes.advertising, label: "Banner oglašavanje", content: <Advertising /> },
            { key: HelpingRoutes.paymentMethods, label: "Načini plaćanja", content: <PaymentMethods /> },
            { key: HelpingRoutes.termsOfUse, label: "Uvjeti korištenja", content: <TermsOfUse /> },
            { key: HelpingRoutes.instructionsForUse, label: "Pravila za predaju oglasa", content: <InstructionsForUse /> },
            { key: HelpingRoutes.privacyPolicy, label: "Pravila o privatnosti", content: <PrivacyPolicy /> },
            { key: HelpingRoutes.faq, label: "Često postavljana pitanja", content: <FAQ /> },
          ]}
        />
      </div>
    </div>
  );
}

Help.defaultProps = {
  match: {},
  settings: defaultSettings
};

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help/Help.tsx